import Axios from 'axios';
import AxiosMiddleware from '../libs/AxiosMiddleware';
import Config from '@/config';
import OPCODE from '@/libs/OPCODE';
import router from '../router';

export const TYPES = {
  CHANGE_AUTH_STATUS: 'CHANGE_AUTH_STATUS',
  UPDATE_AUTH_INFO: 'UPDATE_AUTH_INFO',
  CHANGE_IS_LOADING: 'CHANGE_IS_LOADING',
  SET_DETAILS: 'SET_DETAILS',
};

const state = {
  isLoading: false,
  editing: false,
  isSignin: false,
  details: {},
  idx: '',
  identity: '' /* 아이디 */,
  username: '' /* 닉네임 */,
  balance: {
    /* 금액 */
    current: 0 /* 현재 잔액 */,
    price: 0 /* 월정액 */,
    previous: 0,
    paymentDate: 0 /* 결제 예정일 */,
    paymentType: 0 /* 월정액 / 건당 */,
  },
  apply: {
    always: true,
    startTime: '',
    endTime: '',
  },
};

const mutations = {
  [TYPES.CHANGE_IS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
  [TYPES.CHANGE_AUTH_STATUS](state, isSignin) {
    state.isSignin = isSignin;
    if (!isSignin) {
      state.idx = '';
      state.identity = '';
      state.username = '';
      state.balance = {
        current: 0,
        price: 0,
        previous: 0,
        paymentDate: 0,
        paymentType: 0,
      };

      state.apply = {
        always: true,
        startTime: '',
        endTime: '',
      };
    }
  },
  [TYPES.UPDATE_AUTH_INFO](state, res) {
    state.idx = res.auth.idx;
    state.identity = res.auth.identity;
    state.username = res.auth.username;
    state.balance.current = res.balance.current;
    state.balance.price = res.balance.price;
    state.balance.previous = res.balance.previous;
    state.balance.paymentDate = res.balance.paymentDate;
    state.balance.paymentType = res.balance.paymentType;
    state.apply = res.apply;
  },
  [TYPES.SET_DETAILS](state, res) {
    const { details } = res;
    state.details = details;
  },
};

const actions = {
  async signin({ commit, dispatch }, authInfo) {
    try {
      const { data } = await Axios.post(
        `${Config.hostname}/v1/auth/signin`,
        authInfo,
        { withCredentials: true },
      );

      if (AxiosMiddleware(data.opcode)) {
        switch (data.opcode) {
          case OPCODE.SUCCESS:
            router.push('/');
            commit(TYPES.CHANGE_AUTH_STATUS, data);
            dispatch('refreshMe');
            Config.alert.mixin({
              type: 'success',
              title: '성공적으로 로그인되었습니다.',
            });
            break;
          case OPCODE.EXISTS:
            Config.alert.mixin({
              type: 'error',
              title: '아이디 또는 비밀번호가 잘못되었습니다.',
            });
            break;
          default:
            Config.alert.mixin({
              type: 'error',
              title: '오류가 발생하였습니다.',
            });
        }
      }
    } catch {
      Config.alert.mixin({
        type: 'error',
        title: '인터넷 상태를 확인해주세요.',
      });
    }
  },
  async signup({ commit, dispatch }, authInfo) {
    if (authInfo.password != authInfo.repeatPassword) {
      commit(TYPES.SET_DETAILS, {
        details: { repeatPassword: '비밀번호가 일치하지 않아요.' },
      });

      Config.alert.mixin({
        type: 'warning',
        title: '오류를 확인해주세요.',
      });
      return;
    }

    const { data } = await Axios.post(
      `${Config.hostname}/v1/auth/signup`,
      authInfo,
      { withCredentials: true },
    );

    if (AxiosMiddleware(data.opcode)) {
      switch (data.opcode) {
        case OPCODE.SUCCESS:
          commit(TYPES.CHANGE_AUTH_STATUS, true);
          Config.alert.mixin({
            type: 'success',
            title: '새로운 가족이 되신 것을 진심으로 축하드립니다.',
          });
          dispatch('refreshMe');
          router.push('/');
          break;
        case OPCODE.EXISTS:
          Config.alert.mixin({
            type: 'error',
            title: '해당 아이디 또는 전화번호, 이메일은 사용중입니다.',
          });
          break;
        case OPCODE.INVALID:
          commit(TYPES.SET_DETAILS, data);
          Config.alert.mixin({
            type: 'warning',
            title: '오류를 확인해주세요.',
          });
          break;
      }
    }
  },
  async signout({ commit }) {
    this._vm.$confirm({
      title: '로그아웃',
      content: '정말로 로그아웃하시겠습니까?',
      okText: '네, 로그아웃합니다.',
      okType: 'primary',
      cancelText: '아니요',
      onOk() {
        Axios.get(`${Config.hostname}/v1/auth/signout`, {
          withCredentials: true,
        });

        commit(TYPES.CHANGE_AUTH_STATUS, false);
        router.push('/signin');
        clearInterval(window.refreshMe);
        clearInterval(window.refreshSaibs);
        clearInterval(window.refreshQuestion);
        clearInterval(window.refreshBroadcast);
        clearInterval(window.refreshWholesales);
        clearInterval(window.adminRefreshMe);
        clearInterval(window.uncleRefreshMe);
        clearInterval(window.unclePending);
        clearInterval(window.masterRefreshMe);
        Config.alert.mixin({
          type: 'success',
          title: '성공적으로 로그아웃되었습니다.',
        });
      },
    });
  },
  async refreshMe({ commit }) {
    const { path } = router.currentRoute;

    if (
      !path.startsWith('/admin') &&
      !path.startsWith('/uncle') &&
      !path.startsWith('/master') &&
      !path.startsWith('/req') &&
      !path.startsWith('/find')
    ) {
      try {
        commit(TYPES.CHANGE_IS_LOADING, true);
        const { data } = await Axios.get(`${Config.hostname}/v1/auth/me`, {
          withCredentials: true,
        });
        if (AxiosMiddleware(data.opcode)) {
          switch (data.opcode) {
            case OPCODE.SUCCESS:
              commit(TYPES.CHANGE_AUTH_STATUS, true);
              commit(TYPES.UPDATE_AUTH_INFO, data);
              if (router.history.current.path === '/signin') {
                router.push('/');
              }
              break;
          }
        }

        commit(TYPES.CHANGE_IS_LOADING, false);
      } catch {
        AxiosMiddleware(OPCODE.ACCOUNT.EXISTS);
      }
    }
  },
};

const getters = {};

export default { state, mutations, getters, actions };
